export default "{\n    \"text\": \"{{from}} to {{to}}\"\n}\n"